export default "__VITE_ASSET__DIyD7aJu__"